var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockEight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-eight",
    clipPath: "url(#clip0_8264_261371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6666 0C6.0385 0 0.666626 5.37188 0.666626 12C0.666626 18.6281 6.0385 24 12.6666 24C19.2948 24 24.6666 18.6281 24.6666 12C24.6666 5.37188 19.2948 0 12.6666 0ZM12.6666 22.5C6.87756 22.5 2.16663 17.7891 2.16663 12C2.16663 6.21094 6.87756 1.5 12.6666 1.5C18.4557 1.5 23.1666 6.21094 23.1666 12C23.1666 17.7891 18.4557 22.5 12.6666 22.5ZM12.6666 4.5C12.2541 4.5 11.9166 4.8375 11.9166 5.25V11.5688L8.06819 13.7859C7.71194 13.9969 7.59006 14.4516 7.79631 14.8125C7.93549 15.0535 8.18744 15.1875 8.44694 15.1875C8.57439 15.1875 8.7033 15.1553 8.82119 15.0871L13.0428 12.6496C13.2338 12.5156 13.4166 12.2672 13.4166 12V5.25C13.4166 4.8375 13.0791 4.5 12.6666 4.5Z",
    fill: "#383A3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8264_261371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockEight);
export default __webpack_public_path__ + "static/media/clock-eight.cc6a0424e4d33dd9ea81f49f76ab7a4c.svg";
export { ForwardRef as ReactComponent };